import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MOMENT_DATEPICKER_PROVIDERS } from '@principle-theorem/ng-shared';
import {
  TemplateScope,
  type IAutomatedNotification,
  type IAutomationConfiguration,
  type ITemplateScopeData,
  AutomationContext,
} from '@principle-theorem/principle-core/interfaces';
import {
  type DocumentReference,
  type Timestamp,
} from '@principle-theorem/shared';
import { type Moment } from 'moment-timezone';
import {
  AutomatedNotificationEditComponent,
  IAutomatedNotificationReturnData,
} from '../automated-notification-edit/automated-notification-edit.component';

export interface IAutomatedNotificationDialogData {
  notification?: IAutomatedNotification;
  scope: TemplateScope;
  scopeData: ITemplateScopeData;
  useRelativeTime: boolean;
  context: AutomationContext;
  triggerDate?: Timestamp;
  configRef?: DocumentReference<IAutomationConfiguration>;
}

export interface IAutomatedNotificationFormData extends IAutomatedNotification {
  triggerDate?: Moment;
  triggerTime?: string;
}

@Component({
  selector: 'pr-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [...MOMENT_DATEPICKER_PROVIDERS],
  standalone: false,
})
export class NotificationDialogComponent {
  isEdit: boolean = false;

  constructor(
    private _dialogRef: MatDialogRef<
      NotificationDialogComponent,
      IAutomatedNotificationReturnData
    >,
    @Inject(MAT_DIALOG_DATA) public data: IAutomatedNotificationDialogData
  ) {
    this.isEdit = !!data.notification;
  }

  async submit(form: AutomatedNotificationEditComponent): Promise<void> {
    if (form.form.invalid) {
      return;
    }
    const data = await form.submit();
    this._dialogRef.close(data);
  }
}
